export default __webpack_public_path__ + "static/media/d22.172efee7.png";